export default {
  errorsRootKey: 'invoice/sector',
  resource: 'invoice/sector',
  actions: ['index', 'create', 'show', 'update', 'destroy']
}
